import React from 'react';
import './Services.css';
import fireKeepersLogo from './a.png';
import vp4meLogo from './a2.png';
import coupleCounselingLogo from './c.jpeg';
import GenericModal from './GenericModal';

const Services = () => {
  return (
    <section className="services">
      <h2>?מה אני מחפש.ת</h2>
      <div className="services-container">
        <div className="service-item">
          <img
            src={fireKeepersLogo}
            alt="Fire Keepers"
            className="service-logo"
          />
          <h3>מעגל גברים</h3>
          <p>
            שומרי האש מציעים ליווי ותמיכה לגברים בהתפתחות אישית והגשמה עצמית
            במסגרת קבוצתית תומכת
          </p>
          <GenericModal
            link="https://pay.sumit.co.il/48j3mo/9g43ug/"
            buttonText="למידע נוסף"
            modalTitle="Fire Keepers"
          />
        </div>
        <div className="service-item">
          <img src={vp4meLogo} alt="VP4Me" className="service-logo" />
          <h3>קורס תקשורת מקרבת</h3>
          <p>שירות ייחודי לפיתוח אישי ומקצועי באמצעות כלים מתקדמים</p>
          <GenericModal
            link="https://lp.vp4.me/tzjn"
            buttonText="למידע נוסף"
            modalTitle="קורס תקשורת מקרבת"
          />
        </div>
        <div className="service-item">
          <img
            src={coupleCounselingLogo}
            alt="ייעוץ זוגי"
            className="service-logo"
          />
          <h3>אימון אישי וזוגי</h3>
          <p>
            ייעוץ זוגי שמטרתו לשפר את התקשורת הזוגית ולהתגבר על אתגרים במערכות
            היחסים
          </p>
          <GenericModal
            link="https://pay.sumit.co.il/48j3mo/9e1pp2/"
            buttonText="למידע נוסף"
            modalTitle="קורס תקשורת מקרבת"
          />
        </div>
      </div>
    </section>
  );
};

export default Services;
